import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-primary via-primary/95 to-secondary overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-1/3 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="text-white">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Users" size={24} className="text-white" />
              </div>
              <span className="text-accent font-semibold text-lg">Our Story</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Where <span className="text-gradient-brand bg-gradient-to-r from-accent to-white bg-clip-text text-transparent">Artistry</span> Meets Engineering
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Singh Creations was born from a simple belief: exceptional digital experiences aren't just built, they're crafted with intention, passion, and deep understanding of human behavior.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center space-x-3 text-white/80">
                <Icon name="Calendar" size={20} />
                <span>Founded in 2021</span>
              </div>
              <div className="flex items-center space-x-3 text-white/80">
                <Icon name="MapPin" size={20} />
                <span>Based in Delhi, India</span>
              </div>
              <div className="flex items-center space-x-3 text-white/80">
                <Icon name="Award" size={20} />
                <span>50+ Projects Delivered</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <Image
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Singh Creations team collaborating on digital projects"
                className="w-full h-96 object-cover rounded-2xl brand-shadow"
              />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-accent rounded-2xl flex items-center justify-center brand-shadow">
                <Icon name="Zap" size={32} className="text-white" />
              </div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -top-8 -left-8 bg-white/95 backdrop-blur-sm rounded-2xl p-6 brand-shadow">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">2+</div>
                <div className="text-sm text-muted-foreground">Years Experience</div>
              </div>
            </div>
            
            <div className="absolute -bottom-8 left-8 bg-white/95 backdrop-blur-sm rounded-2xl p-6 brand-shadow">
              <div className="text-center">
                <div className="text-3xl font-bold text-accent">98%</div>
                <div className="text-sm text-muted-foreground">Client Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;